import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "lc_ttop"
};
const _hoisted_2 = {
  class: "lc-bsinfo"
};
const _hoisted_3 = {
  class: "lc_title1"
};
const _hoisted_4 = {
  style: {
    "padding-bottom": "50px"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_LcButtons = _resolveComponent("LcButtons");
  const _component_lcBaseInfo = _resolveComponent("lcBaseInfo");
  const _component_el_checkbox = _resolveComponent("el-checkbox");
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group");
  const _component_lcwjsc = _resolveComponent("lcwjsc");
  const _component_lctinymce = _resolveComponent("lctinymce");
  const _component_LcWriteLinks = _resolveComponent("LcWriteLinks");
  const _component_el_main = _resolveComponent("el-main");
  return _openBlock(), _createBlock(_component_el_main, {
    class: "bg_white wrap_box lc_rw"
  }, {
    default: _withCtx(() => [_createVNode(_component_LcButtons, {
      ref: "lcButtons",
      type: 2,
      onBtsEmit: _cache[0] || (_cache[0] = $event => _ctx.btsEmit($event)),
      planStratTime: _ctx.data.baseInfo.plan_start_time_text,
      ids: _ctx.ids,
      projectName: _ctx.data.baseInfo.project_name,
      reviewerUserId: _ctx.data.baseInfo.reviewer_user_id,
      userId: _ctx.data.baseInfo.leader_user_id,
      msg: _ctx.data.baseInfo.msg,
      onGetPageInfo: _ctx.getPageInfo,
      deppgetPageInfo: _ctx.getPageInfo
    }, null, 8, ["planStratTime", "ids", "projectName", "reviewerUserId", "userId", "msg", "onGetPageInfo", "deppgetPageInfo"]), _createElementVNode("div", _hoisted_1, [_createVNode(_component_lcBaseInfo, {
      ref: "addBaseInfo",
      type: "taskInfo"
    }, null, 512)]), _createElementVNode("div", _hoisted_2, [_cache[5] || (_cache[5] = _createElementVNode("div", {
      class: "lc_title lc_ttop lc_add_ggdyb"
    }, "知识产权需求", -1)), _cache[6] || (_cache[6] = _createElementVNode("div", {
      class: "lc_title1"
    }, "专利类型", -1)), _createVNode(_component_el_checkbox_group, {
      modelValue: _ctx.data.zlchecks,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.data.zlchecks = $event),
      style: {
        "padding": "10px 0"
      }
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.patent_type, (item, index) => {
        return _openBlock(), _createBlock(_component_el_checkbox, {
          key: index,
          label: item.key
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(item.name), 1)]),
          _: 2
        }, 1032, ["label"]);
      }), 128))]),
      _: 1
    }, 8, ["modelValue"]), _cache[7] || (_cache[7] = _createElementVNode("div", {
      class: "lc_title1"
    }, "国家", -1)), _createVNode(_component_el_checkbox_group, {
      modelValue: _ctx.data.countrychecks,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _ctx.data.countrychecks = $event),
      style: {
        "padding": "10px 0"
      }
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.country, (item, index) => {
        return _openBlock(), _createBlock(_component_el_checkbox, {
          key: index,
          label: item.key
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(item.name), 1)]),
          _: 2
        }, 1032, ["label"]);
      }), 128))]),
      _: 1
    }, 8, ["modelValue"]), _cache[8] || (_cache[8] = _createElementVNode("div", {
      class: "lc_title lc_ttop lc_add_ggdyb"
    }, "输出文件", -1)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.tableAfterArr, (item, index) => {
      return _openBlock(), _createElementBlock("div", {
        key: index
      }, [_createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.data['table_title_' + item]), 1), _createVNode(_component_lcwjsc, {
        loading: _ctx.data['loading_' + item],
        "onUpdate:loading": $event => _ctx.data['loading_' + item] = $event,
        code: _ctx.data.tableAfterArr[index],
        "onUpdate:code": $event => _ctx.data.tableAfterArr[index] = $event,
        tableHeigth: _ctx.data['tableHeigth_' + item],
        "onUpdate:tableHeigth": $event => _ctx.data['tableHeigth_' + item] = $event,
        listHeader: _ctx.data['listHeader_' + item],
        "onUpdate:listHeader": $event => _ctx.data['listHeader_' + item] = $event,
        defaultRow: _ctx.data['defaultRow_' + item],
        "onUpdate:defaultRow": $event => _ctx.data['defaultRow_' + item] = $event,
        tableHeader: _ctx.data['tableHeader_' + item],
        "onUpdate:tableHeader": $event => _ctx.data['tableHeader_' + item] = $event,
        notShowCol: _ctx.data['notShowCol_' + item],
        "onUpdate:notShowCol": $event => _ctx.data['notShowCol_' + item] = $event,
        staticList: _ctx.data['staticList_' + item],
        "onUpdate:staticList": $event => _ctx.data['staticList_' + item] = $event,
        beforeStrList: _ctx.data['beforeStrList_' + item],
        "onUpdate:beforeStrList": $event => _ctx.data['beforeStrList_' + item] = $event,
        onGetClickBtnType: _ctx.getClickBtnTypeMany,
        onUploadAddRow: _ctx.uploadAddRowMany,
        onEditDataEmit: _ctx.editDataEmitMany
      }, null, 8, ["loading", "onUpdate:loading", "code", "onUpdate:code", "tableHeigth", "onUpdate:tableHeigth", "listHeader", "onUpdate:listHeader", "defaultRow", "onUpdate:defaultRow", "tableHeader", "onUpdate:tableHeader", "notShowCol", "onUpdate:notShowCol", "staticList", "onUpdate:staticList", "beforeStrList", "onUpdate:beforeStrList", "onGetClickBtnType", "onUploadAddRow", "onEditDataEmit"])]);
    }), 128)), _cache[9] || (_cache[9] = _createElementVNode("div", {
      class: "lc_ttop lc_bzt"
    }, "备注", -1)), _createElementVNode("div", _hoisted_4, [(_openBlock(), _createBlock(_component_lctinymce, {
      id: _ctx.data.id,
      ref: "editor",
      height: _ctx.data.height,
      "cur-value": _ctx.data.remark,
      onInput: _ctx.inputContent,
      key: _ctx.data.key
    }, null, 8, ["id", "height", "cur-value", "onInput"]))])]), (_openBlock(), _createBlock(_component_LcWriteLinks, {
      key: _ctx.data.isShowLinksDialogIndex,
      isShowLinksDialog: _ctx.data.isShowLinksDialog,
      "onUpdate:isShowLinksDialog": _cache[3] || (_cache[3] = $event => _ctx.data.isShowLinksDialog = $event),
      linksTitle: _ctx.data.linksTitle,
      "onUpdate:linksTitle": _cache[4] || (_cache[4] = $event => _ctx.data.linksTitle = $event),
      onGetDragWriteData: _ctx.getDragWriteData
    }, null, 8, ["isShowLinksDialog", "linksTitle", "onGetDragWriteData"]))]),
    _: 1
  });
}